import React, { useCallback } from 'react';
import AdminPage from '../../../components/admin/AdminPage';
import { ModelUnitFinancesForm } from '../../investors/models/investors';
import { updateModelUnitFinancesEndpoint } from '../../investors/services/investorService';
import { fetchResponseAdapter } from '../../../adapters/fetchAdapter';
import useCallApiAndLoad from '../../../hooks/useCallApiAndLoad';
import { useNavigate, useParams } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';
import ManageModelUnitQuotationForm from './ManageModelUnitQuotationForm';

const ModelUnitQuotation: React.FC = () => {
  const {id: investorProjectModelId = "", modelUnitId = ""} = useParams();
  const { callEndpoint } = useCallApiAndLoad();
  const navigate = useNavigate();
  const { getAuthToken } = useAuth();
  const token = getAuthToken();

  const updateFinanceInfo = useCallback(async (form: ModelUnitFinancesForm, errorRepository: Function) => {
    const {
      status, data
    } = await callEndpoint(updateModelUnitFinancesEndpoint(investorProjectModelId, modelUnitId, form, token));

    const response = fetchResponseAdapter(data);

    if (status === 200)
      navigate(`/investors/models/${investorProjectModelId}/model-units`)
    else
      errorRepository(response.message);
  }, [callEndpoint, investorProjectModelId, modelUnitId, navigate, token]);

  const pageName = "Cotización de la unidad"
  const pageParentName = "Preventa"

  return (
    <AdminPage name={pageName} parentName={pageParentName}>
      <ManageModelUnitQuotationForm projectModelId={investorProjectModelId} modelUnitId={modelUnitId} handleForm={updateFinanceInfo} />
    </AdminPage>
  );
};

export default ModelUnitQuotation;